import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFileLines = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.25 19.313a.564.564 0 0 1-.562-.563V5.25c0-.31.253-.562.562-.562h5.625V7.5c0 .622.503 1.125 1.125 1.125h2.813V18.75c0 .31-.254.563-.563.563zM7.25 3A2.25 2.25 0 0 0 5 5.25v13.5A2.25 2.25 0 0 0 7.25 21h9a2.25 2.25 0 0 0 2.25-2.25V8.432a2.25 2.25 0 0 0-.657-1.593l-3.186-3.182A2.24 2.24 0 0 0 13.068 3zm1.969 9a.84.84 0 0 0-.844.844c0 .467.376.844.844.844h5.062a.84.84 0 0 0 .844-.844.84.84 0 0 0-.844-.844zm0 3.375a.84.84 0 0 0-.844.844c0 .467.376.843.844.843h5.062a.84.84 0 0 0 .844-.843.84.84 0 0 0-.844-.844z"
    }));
export default SvgFileLines;
